<ng-container>
  <h5>Queue Strategy</h5>
  <div class="extension-detail-item">{{ extensionQueue?.queueStrategyId | addSpaces }}</div>
</ng-container>
<ng-container>
  <h5>Wrap Up Time</h5>
  <div class="extension-detail-item">{{ extensionQueue?.wrapUpTime }}</div>
</ng-container>
<ng-container>
  <h5>Announcements</h5>
  @if (extensionQueue?.isAnnounceQueueCount || extensionQueue?.isAnnounceWaitTime) {
    <div class="extension-detail-item"
      >Every {{ extensionQueue?.announcementFrequency }} Minute{{
      extensionQueue?.announcementFrequency > 1 ? 's' : ''
      }}</div
      >
    }
    @if (extensionQueue?.isAnnounceWaitTime) {
      <div class="extension-detail-item">Wait Time</div>
    }
    @if (extensionQueue?.isAnnounceQueueCount) {
      <div class="extension-detail-item">Queue Count</div>
    }
    @if (extensionQueue?.isAnnounceCallback) {
      <div class="extension-detail-item">Callback Prompt</div>
    }
    @if (
      !extensionQueue?.isAnnounceQueueCount &&
      !extensionQueue?.isAnnounceWaitTime &&
      !extensionQueue?.isAnnounceCallback
      ) {
      <div
        class="extension-detail-item"
        >None</div
        >
      }
    </ng-container>
    @if (extensionQueue?.queueMembersConnection) {
      <h5>Logged In Agents</h5>
      @for (agent of distinctAgents; track agent) {
        @if (agent.isLoggedIn) {
          <div class="extension-detail-item logged-in-agents-list">
            <div>{{ agent.agentExtension.name }}</div>
            <div class="agent-status-container">
              {{ agent.agentStatus | agentStatus : agent.endWrapUpTime }}
              <a class="log-out-agent-link" (click)="onLogOutAgentClick(agent)">(Log Out)</a>
            </div>
          </div>
        }
      }
    }
